/* import __COLOCATED_TEMPLATE__ from './navigation-narrator.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { registerDestructor } from '@ember/destroyable';
import { inject as service } from '@ember/service';
import { schedule, cancel } from '@ember/runloop';
import { tracked } from '@glimmer/tracking';
import { defaultValidator } from 'ember-a11y-refocus';
let NavigationNarratorComponent = (_class = class NavigationNarratorComponent extends Component {
  get skipLink() {
    return this.args.skipLink ?? true;
  }
  get skipTo() {
    return this.args.skipTo ?? '#main';
  }
  get skipText() {
    return this.args.skipText ?? 'Skip to main content';
  }
  get navigationText() {
    return this.args.navigationText ?? 'The page navigation is complete. You may now navigate the page content as you wish.';
  }
  get routeChangeValidator() {
    return this.args.routeChangeValidator ?? defaultValidator;
  }
  constructor() {
    super(...arguments);

    // focus on the navigation message after render
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "isSkipLinkFocused", _descriptor2, this);
    _defineProperty(this, "timer", null);
    this.router.on('routeDidChange', this.onRouteChange);
    registerDestructor(this, () => {
      cancel(this.timer);
      this.timer = null;
      this.router.off('routeDidChange', this.onRouteChange);
    });
  }
  onRouteChange(transition) {
    let shouldFocus = this.routeChangeValidator(transition);
    if (!shouldFocus) {
      return;
    }
    this.timer = schedule('afterRender', this, function () {
      this.timer = null;
      document.body.querySelector('#ember-a11y-refocus-nav-message').focus();
    });
  }
  handleSkipLinkFocus() {
    this.isSkipLinkFocused = !this.isSkipLinkFocused;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isSkipLinkFocused", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onRouteChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onRouteChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSkipLinkFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSkipLinkFocus"), _class.prototype)), _class);
export { NavigationNarratorComponent as default };